/**
 * *大健康门店系统 相关路由
 * ! 跟代理中心联动的路由需要在代理中心加storePath
 */
const storeRouterList = [
  // * 大健康门店系统 - 客户管理
  {
    name: 'storeCustomerManagement',
    path: '/store/storeCustomerManagement',
    meta: { title: '客户管理', topNavName: '客户管理', vznaStore: true },
    component: () => import('../../pages/agent/agents.vue'),
  },
  {
    name: 'storeHealthUserDetail',
    path: '/store/healthUserDetail',
    meta: { title: '观众详情', topNavName: '观众详情', vznaStore: true },
    component: () => import('../../pages/agent/healthUserDetail.vue'),
  },
  {
    name: 'storeCustomerDetail',
    path: '/store/storeCustomerDetail',
    meta: { title: '客户详情', topNavName: '客户详情', vznaStore: true },
    component: () => import('../../pages/agent/customerDetail.vue'),
  },
  {
    name: 'storeMemberManage',
    path: '/store/storeMemberManage',
    meta: { title: '会员管理', topNavName: '会员管理', vznaStore: true },
    component: () => import('../../pages/agent/memberManage.vue'),
  },
  {
    name: 'storeConsumptionList',
    path: '/store/storeConsumptionList',
    meta: { title: '消费榜', topNavName: '消费榜', vznaStore: true },
    component: () => import('../../pages/agent/consumptionList.vue'),
  },

  // 代理管理
  {
    name: 'storeTeam',
    path: '/store/storeTeam',
    meta: { title: '代理管理', topNavName: '代理管理', vznaStore: true },
    component: () => import('../../pages/agent/MyTeam.vue'),
  },

  {
    name: 'storeAgentTopics',
    path: '/store/storeAgentTopics',
    meta: { title: '代理中心', topNavName: '代理中心', vznaStore: true },
    component: () => import('../../pages/agent/topics.vue'),
  },

  {
    name: 'storeDownloadCenter',
    path: '/store/downloadCenter',
    meta: { title: '下载中心', topNavName: '下载中心', vznaStore: true },
    component: () => import('../../pages/agent/downloadCenter.vue'),
  },

  {
    name: 'storeTradeComplaint',
    path: '/store/tradeComplaint',
    meta: { title: '交易投诉', topNavName: '交易投诉', vznaStore: true },
    component: () => import('../../pages/agent/tradeComplaint.vue'),
  },

  /**
   * * 数据统计模块
   * */
  {
    name: 'storeRecordNew',
    path: '/store/storeRecord',
    meta: { title: '商品统计', topNavName: '商品统计', vznaStore: true },
    component: () => import('../../pages/agent/StoreRecord.vue'),
  },

  {
    name: 'storeRecordNew',
    path: '/store/checkorder',
    meta: {
      title: '订单详情',
      topNavName: '订单详情',
      vznaStore: true,
      fromType: 'checkorder',
    },
    component: () => import('../../pages/order/checkorder.vue'),
  },

  {
    name: 'storeOperationStatement',
    path: '/store/operationStatement',
    meta: { title: '经营报表', topNavName: '经营报表', vznaStore: true },
    component: () => import('../../pages/agent/operationStatement.vue'),
  },

  {
    name: 'storeGoodsStatistics',
    path: '/store/goodsStatistics',
    meta: {
      title: '商品统计',
      topNavName: '商品统计',
      vznaStore: true,
    },
    component: () => import('../../pages/agent/goodsStatistics.vue'),
  },

  /**
   * * 营销
   * */
  {
    name: 'storeCollectCard',
    path: '/store/collectCard',
    meta: { title: '集卡活动', topNavName: '集卡活动', vznaStore: true },
    component: () => import('@/pages/mine/collectCard.vue'),
  },

  {
    name: 'storeCollectCardRecord',
    path: '/store/collectCard/record',
    meta: { title: '领取记录', topNavName: '领取记录', vznaStore: true },
    component: () =>
      import('@/pages/mine/components/collectCard/cardRecord.vue'),
  },

  {
    name: 'storePayGift',
    path: '/store/payGift',
    meta: { title: '支付有礼', topNavName: '支付有礼', vznaStore: true },
    component: () => import('../../pages/agent/PayGift/index.vue'),
  },

  {
    name: 'storeActivityRecords',
    path: '/store/payGift/records',
    meta: { title: '支付有礼', topNavName: '支付有礼', vznaStore: true },
    component: () => import('../../pages/agent/PayGift/activityRecords.vue'),
  },

  /**
   * * 配套工具
   * */
  // * 在途配送（采购模式）
  {
    name: 'storeDeliveryProcureNote',
    path: '/store/deliveryProcureNote',
    meta: { title: '在途配送', topNavName: '在途配送', vznaStore: true },
    component: () => import('../../pages/agent/deliveryProcureNote.vue'),
  },
  // 发货单-物流轨迹
  {
    name: 'storeDeliveryNoteLogistics',
    path: '/store/deliveryNoteLogistics',
    meta: { title: '在途配送', topNavName: '在途配送', vznaStore: true },
    component: () => import('../../pages/agent/deliveryNoteLogistics.vue'),
  },

  // * 发货单详情-商品列表
  {
    name: 'storeDeliveryNoteProductList',
    path: '/store/deliveryNoteProductList',
    meta: { title: '在途配送', topNavName: '在途配送', vznaStore: true },
    component: () => import('../../pages/agent/deliveryNoteProductList.vue'),
  },

  {
    name: 'storeVerfiyRecord',
    path: '/store/verify/verifyRecord',
    meta: { title: '核销记录', topNavName: '核销记录', vznaStore: true },
    component: () => import('@/pages/agent/verify/record.vue'),
  },
  // 代理详情
  {
    name: 'storeAgentDetail',
    path: '/store/storeAgentDetail',
    meta: { title: '代理详情', topNavName: '代理详情', vznaStore: true },
    component: () => import('../../pages/agent/detail.vue'),
  },
  // 代理业绩
  {
    name: 'storeAgentPerformance',
    path: '/store/storeAgentPerformance',
    meta: { title: '代理业绩', topNavName: '代理业绩', vznaStore: true },
    component: () => import('../../pages/agent/agentPerformance.vue'),
  },
  // 提现中心
  {
    name: 'storeDetailCommission',
    path: '/store/commission/detail',
    meta: { title: '提现中心', topNavName: '提现中心', vznaStore: true },
    component: () => import('../../pages/commission/DetailCommission.vue'),
  },
  // 易宝提现中心
  {
    name: 'storeYeeDetailCommission',
    path: '/store/commission/yeeDetail',
    meta: { title: '提现中心', topNavName: '提现中心', vznaStore: true },
    component: () =>
      import('@/pages/commission/YeeDetailCommission/YeeDetailCommission.vue'),
  },
  // 提现明细
  {
    name: 'storeWithdrawalrecord',
    path: '/store/commission/withdrawalrecord',
    meta: { title: '提现明细', topNavName: '提现明细', vznaStore: true },
    component: () => import('../../pages/commission/WithdrawalRecorde.vue'),
  },
  // 易宝提现明细
  {
    name: 'storeYeeWithdrawalrecord',
    path: '/store/commission/yeeWithdrawalrecord',
    meta: { title: '提现明细', topNavName: '提现明细', vznaStore: true },
    component: () => import('../../pages/commission/YeeWithdrawalRecorde.vue'),
  },
  {
    name: 'storeOrderKPI',
    path: '/store/orderKPI',
    meta: {
      title: '订单统计',
      topNavName: '订单统计',
      vznaStore: true,
    },
    component: () => import('../../pages/agent/orderKPI.vue'),
  },
  {
    path: '/store/commission/incomepage',
    name: 'storeIncomePage',
    meta: {
      title: '收益明细-自动结算',
      topNavName: '收益明细-自动结算',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/IncomePage.vue'),
  },
  {
    path: '/store/commission/incomepagemanual',
    name: 'storeIncomePageManual',
    meta: {
      title: '收益明细-对账结算',
      topNavName: '收益明细-对账结算',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/IncomePageManual.vue'),
  },
  {
    path: '/store/commission/yeeIncomepage',
    name: 'storeYeeIncomePage',
    meta: {
      title: '收益明细-自动结算',
      topNavName: '收益明细-自动结算',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/YeeIncomePage.vue'),
  },
  {
    path: '/store/commission/yeeIncomepagemanual',
    name: 'storeYeeIncomePageManual',
    meta: {
      title: '收益明细-对账结算',
      topNavName: '收益明细-对账结算',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/YeeIncomePageManual.vue'),
  },
  {
    path: '/store/commission/balanceDetail',
    name: 'storeBalanceDetail',
    meta: {
      title: '账户余额明细',
      topNavName: '账户余额明细',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/BalanceDetail.vue'),
  },
  /** 易宝账户余额明细 */
  {
    path: '/store/commission/yeeBalanceDetail',
    name: 'storeBalanceDetail',
    meta: {
      title: '账户余额明细',
      topNavName: '账户余额明细',
      vznaStore: true,
    },
    component: () =>
      import('@/pages/commission/YeeBalanceDetail/YeeBalanceDetail.vue'),
  },
  {
    path: '/store/commission/cardbind',
    name: 'storeCardbind',
    meta: {
      title: '银行卡换绑',
      topNavName: '银行卡换绑',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/CardBind.vue'),
  },
  {
    path: '/store/commission/YeeCardbind',
    name: 'storeYeeCardbind',
    meta: {
      title: '银行卡换绑',
      topNavName: '银行卡换绑',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/YeeCardBind.vue'),
  },
  {
    path: '/store/commission/cardbindinguser',
    name: 'storeCardbindinguser',
    meta: {
      title: '用户银行卡绑定',
      topNavName: '用户银行卡绑定',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/CardBindingUser.vue'),
  },
  {
    path: '/store/commission/yeeCardbindinguser',
    name: 'storeYeeCardbindinguser',
    meta: {
      title: '用户银行卡绑定',
      topNavName: '用户银行卡绑定',
      vznaStore: true,
    },
    component: () => import('@/pages/commission/YeeCardBindingUser.vue'),
  },
  {
    name: 'storeCouponDetail',
    path: '/store/couponDetail',
    meta: { title: '优惠券详情', topNavName: '优惠券详情', vznaStore: true },
    component: () => import('../../pages/agent/couponDetail.vue'),
  },
  /**
   * * 门店开播申请成功
   * */
  {
    name: 'liveApplicationSuccess',
    path: '/store/liveApplication/success',
    meta: { title: '申请成功', topNavName: '申请成功', vznaStore: true },
    component: () =>
      import('../../pages/storeLivePlay/liveApplicationSuccess.vue'),
  },
]

export default storeRouterList
